import { render, staticRenderFns } from "./no-auth.vue?vue&type=template&id=0b624da4&scoped=true&"
import script from "./no-auth.vue?vue&type=script&lang=ts&"
export * from "./no-auth.vue?vue&type=script&lang=ts&"
import style0 from "./no-auth.vue?vue&type=style&index=0&id=0b624da4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b624da4",
  null
  
)

export default component.exports